import type { DomainMapper } from '../types';

const no: DomainMapper = {
  countryCode: 'no',
  currency: 'NOK',
  dataAreaId: 'no32',
  domain: 'kahrs-preview.iveo.store',
  environment: 'preview',
  flagUrl: '/flags/NO.svg',
  languagePrimary: true,
  locale: 'no',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  productBasePath: 'produkt',
  sitemapUrl: 'https://kahrs-preview.stage3.iveo.se/storage/sitemaps/sitemap-no.xml',
  storyblokBasePath: 'no',
  url: 'https://kahrs-preview.iveo.store/no',
  algoliaIndex: 'b2b-no-nb-NO-products',
  algoliaIndexAutocomplete: 'b2b-no-nb-NO-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1356,
  subFolder: true,
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1356,
    algoliaIndex: 'b2b-no-nb-NO-products',
    algoliaIndexAutocomplete: 'b2b-no-nb-NO-products_query_suggestions',
    displayIncVat: false,
    default: false,
    productBasePath: 'b2b/produkt',
    sitemapUrl: 'https://kahrs-preview.stage3.iveo.se/storage/sitemaps/sitemap-no.xml',
    features: {
      enableCheckoutV2: true,
    },
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1474,
    algoliaIndex: 'b2c-no-nb-NO-products',
    algoliaIndexAutocomplete: 'b2c-no-nb-NO-products_query_suggestions',
    displayIncVat: true,
    default: true,
    productBasePath: 'produkt',
    sitemapUrl: 'https://kahrs-preview.stage3.iveo.se/storage/sitemaps/sitemap-no-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
    sampleInventory: true,
    disableShipToConsumer: true,
  },
  showNonPublicProducts: true,
} as DomainMapper;

export default no;
